import { Breadcrumb, message, Select } from 'antd'
import api, { MetadataAttribute, MetadataEntity } from 'api'
import AppAction from 'components/AppAction/AppAction'
import AppTableAction from 'components/AppAction/AppTableAction'
import AppDialog from 'components/AppDialog'
import { AppGridHeard } from 'components/AppGridLayout/AppGridHeard'
import AppGridLayout from 'components/AppGridLayout/AppGridLayout'
import AppGridMenu from 'components/AppGridLayout/AppGridMenu'
import AppGridTabs from 'components/AppGridLayout/AppGridTabs'
import AppGridView from 'components/AppGridLayout/AppGridView'
import AppMessage from 'components/AppMessage'
import { AppTable } from 'components/AppTable'
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'
import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router'
import { GetQueryString } from 'utils'

import EntityEditFieldPage from './components/EntityEditFieldPage'
import EntityFieldPage from './components/EntityFieldPage'

const { Option } = Select
// 数据对象-编辑数据表
export default class EntityEditPage extends Component<RouteComponentProps> {
	state = {
		tabIndex: 0,
		parent: {} as any,
		dataSource: [] as MetadataEntity,
		entityId: Number(GetQueryString('entityId')),
		application: GetQueryString('application'),
		saveData: false,
	}
	// 初始化
	componentWillMount = async () => {
		let { dataSource, entityId, application } = this.state
		dataSource = await api.modeling.entity.getOne({ id: entityId, application })
		this.setState({ dataSource })
		this.refreshTable(dataSource.metadataAttributeList)
	}
	// 添加
	addTableItem = () => {
		let metadataEntity = this.state.dataSource
		AppDialog.open(
			<EntityFieldPage
				mode={1}
				metadataEntity={metadataEntity}
				afterSave={data => this.refreshTable(data.metadataAttributeList)}
			/>,
			{
				title: '新增字段',
				height: 500,
			}
		)
	}
	// 编辑
	editTableItem = async (metadataAttribute: MetadataAttribute) => {
		let metadataEntity = this.state.dataSource
		AppDialog.open(
			<EntityEditFieldPage
				mode={2}
				metadataEntity={metadataEntity}
				metadataAttribute={metadataAttribute}
				afterSave={data => this.refreshTable(data.metadataAttributeList)}
			/>,
			{
				title: '编辑字段',
				height: 500,
			}
		)
	}
	// 删除
	deleteTableItem = async (data: MetadataEntity) => {
		let res = await AppMessage.confirm('您确定要删除该字段吗？', true)
		if (res) {
			let { dataSource } = this.state
			dataSource.metadataAttributeList = dataSource.metadataAttributeList.filter(e => e.id !== data.id)
			let ret = await api.modeling.entity.updateTable(dataSource)
			if (!ret) {
				return
			}
			message.success('操作成功！')
			this.setState({ dataSource })
			this.refreshTable(dataSource.metadataAttributeList)
		}
	}
	// 保存
	saveDataSheet = async () => {
		let { dataSource } = this.state
		if (!dataSource) return
		let res = await api.modeling.entity.updateTable(dataSource)
		if (!res) {
			return
		}
		message.success('保存成功！')
	}
	// 刷新
	refreshTable = (dataSource: any[]) => {
		this.refTable && this.refTable.current && this.refTable.current.fetchDataSource(dataSource)
	}
	refTable = React.createRef<AppTable>()
	render() {
		return (
			<AppGridLayout defaultViewId={-1} style={{ height: ' calc(100% - 45px)' }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						padding: '10px 0',
						backgroundColor: 'rgba(0,0,0,.2)',
					}}
				>
					<Breadcrumb>
						<Breadcrumb.Item
							onClick={() => {
								this.props.history.go(-1)
							}}
							href={this.state.parent.path}
						>
							{this.state.parent.name}
						</Breadcrumb.Item>
						<Breadcrumb.Item>设计数据表</Breadcrumb.Item>
					</Breadcrumb>
				</div>
				<AppGridSearch></AppGridSearch>
				<AppGridHeard>
					<AppGridTabs></AppGridTabs>
					<AppGridMenu>
						<AppAction title="新增" type="primary" action={this.addTableItem}></AppAction>
					</AppGridMenu>
				</AppGridHeard>
				<AppGridView viewId={-1}>
					<AppTable
						rowKey="entityId"
						dataSource={this.state.dataSource.metadataAttributeList}
						ref={this.refTable}
						data={this.state.dataSource.metadataAttributeList}
						onApiBefore={data => {
							return data.organId === 0 ? false : data
						}}
					>
						<AppTable.ColIndex />
						<AppTable.Col title="中文名" align="center" field="displayName" width={200} />
						<AppTable.Col title="英文名" align="center" field="name" width={200} />
						<AppTable.Col
							title="是否系统级"
							align="center"
							field="isSystem"
							render={(data: MetadataAttribute) => {
								return <span>{data.isSystem ? '是' : '否'}</span>
							}}
						/>
						<AppTable.Col title="字段类型" align="center" field="attributeType" />
						<AppTable.Col title="数据库字段类型" align="center" field="dbType" />
						<AppTable.Col
							title="是否允许为空"
							align="center"
							field="isNullable"
							render={(data: MetadataAttribute) => {
								return <span>{data.isNullable ? '是' : '否'}</span>
							}}
						/>
						<AppTable.Col
							title="是否主键字段"
							align="center"
							field="isPrimaryAttribute"
							render={(data: MetadataAttribute) => {
								return <span>{data.isPrimaryAttribute ? '是' : '否'}</span>
							}}
						/>
						<AppTable.Col title="字段长度" align="center" field="length" />
						<AppTable.ColAction
							render={(data: MetadataEntity) => {
								return (
									<React.Fragment>
										{data.isSystem ? (
											''
										) : (
											<AppTableAction
												onClick={() => {
													this.editTableItem(data)
												}}
												label="编辑"
											/>
										)}
										{data.isSystem ? (
											''
										) : (
											<AppTableAction onClick={() => this.deleteTableItem(data)} label="删除" />
										)}
									</React.Fragment>
								)
							}}
						/>
					</AppTable>
				</AppGridView>
			</AppGridLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/EntityEditPage.tsx